<div class="entry-list-item fs-18-16">
  <ng-content></ng-content>
</div>
